"use strict";
export const assertType = (x) => x;
